import { lazy, Suspense } from 'react';
import Fallback from '../custom/fallback/fallback';
import DashboardLayout from "./dashboardLayout/dashboardLayout";
const Main = lazy(() => import('../components/printDocuments/main'));

const PrintDocuments = () => {
    return (
        <DashboardLayout 
            heading="Print Documents"
        >
            <Suspense fallback={<Fallback />}>
                <Main />
            </Suspense>
        </DashboardLayout>
    );
};

export default PrintDocuments;